import React from 'react';
import PropTypes from 'prop-types';

const TimelineGroup = (props) => {
  const {date} = props;
  return (
      <li className="time-label">
        <span className="bg-aqua">
          {date}
          </span>
      </li>
  );
};

TimelineGroup.propTypes = {
  date: PropTypes.string
};

export default TimelineGroup;





// WEBPACK FOOTER //
// ./src/component/Timeline/TimelineGroup.js